import styled from '@emotion/styled';
import { Box, Modal } from '@mui/material';

import { HeadlineSmall, Row } from '@dh/styles';
import { shouldForwardProps } from '@dh/utils';

export const ModalContainer = styled(Modal, shouldForwardProps)`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: ${({ theme }) => theme.zIndex.modal};
    inset: 0;
`;

export const EllipsedHeadline = styled(HeadlineSmall)`
    overflow: hidden;
    position: relative;
    display: inline-block;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const WrapHeadline = styled(HeadlineSmall)`
    overflow: visible;
    position: relative;
    display: inline-block;
    text-overflow: unset;
    white-space: break-spaces;
`;

export const ButtonRow = styled(Row, shouldForwardProps)<{
    isCompact?: boolean;
}>`
    justify-content: ${({ isCompact }) => (isCompact ? 'space-between' : 'flex-end')};
    gap: ${({ theme }) => theme.spacing(1)};
`;

export const ModalContent = styled(Box, shouldForwardProps)<{ isFullscreen?: boolean }>`
    display: grid;
    grid-template-rows: auto 1fr 48px;
    background-color: ${({ theme }) => theme.colors.surface};
    border-radius: 8px;
    padding: ${({ theme }) => theme.spacing(3)};
    height: ${({ isFullscreen }) => (isFullscreen ? '95%' : 'auto')};
    width: ${({ isFullscreen }) => (isFullscreen ? '95%' : 'auto')};
    min-width: calc(15 * 32px);
    max-width: calc(100vw - 32px);
`;
